// Componente per sistema ExeDialog DDT2026 - Step conferma finale
//
// In modalità coupon (SPECCOUPON2026.md) questa è anche la pagina in cui si
// chiede il cellulare del conducente: è obbligatorio perché serve all'invio
// dell'SMS che segue il salvataggio del coupon (SPECS_COUPON.md, Parte 3),
// e qui l'utente lo rivede insieme al resto del riepilogo prima di confermare.
import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { isCouponMode, TARA_DA_VEICOLO } from '../couponMode';
import { ValoriVerificati } from './ValoriVerificati';

// Cellulare: cifre, con eventuale prefisso internazionale e separatori
function cellulareValido(v) {
    return /^\+?[\d\s.-]{8,20}$/.test((v || '').trim());
}

export function Conferma(props) {
    const { currURLSearchParams, onFinish, loading } = props;

    const isCoupon = isCouponMode(currURLSearchParams);
    const [cellulare, setCellulare] = useState(currURLSearchParams.get('cellulare') || '');

    const cellulareOk = !isCoupon || cellulareValido(cellulare);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!cellulareOk) return;
        onFinish(isCoupon
            ? { cellulare: cellulare.trim(), conferma: true }
            : { conferma: true });
    };

    const tara = parseFloat(currURLSearchParams.get('tara')) || 0;
    const lordo = parseFloat(currURLSearchParams.get('lordo')) || 0;
    const netto = lordo - tara;

    // Riepilogo dati: nel coupon numero, data e lordo sono dati dinamici
    // assegnati all'attivazione, al loro posto si mostrano le correzioni di peso
    const dati = {
        'Codice Bolla': currURLSearchParams.get('cod_bolla'),
        ...(isCoupon ? {} : {
            'Numero Bolla': currURLSearchParams.get('num_bolla'),
            'Data': currURLSearchParams.get('data_bolla') ? new Date(currURLSearchParams.get('data_bolla')).toLocaleString() : null,
        }),
        'Ragione Sociale': currURLSearchParams.get('rag_soc'),
        'Targa': currURLSearchParams.get('targa'),
        'Vettore': currURLSearchParams.get('rag_soc_vettore'),
        'Conducente': currURLSearchParams.get('rag_soc_conducente'),
        'Commessa': currURLSearchParams.get('cod_commessa'),
        'Articolo': currURLSearchParams.get('descrizion'),
        'Destinazione': currURLSearchParams.get('destinazione'),
        ...(isCoupon ? {
            'Tara': tara === TARA_DA_VEICOLO ? `${TARA_DA_VEICOLO} (tara del veicolo)` : currURLSearchParams.get('tara'),
            'Correzione tara (dtara)': currURLSearchParams.get('dtara') || '0',
            'Correzione lordo (dlordo)': currURLSearchParams.get('dlordo') || '0',
        } : {
            'Lordo': currURLSearchParams.get('lordo'),
            'Tara': currURLSearchParams.get('tara'),
        }),
        'CIG': currURLSearchParams.get('cig'),
        'CUP': currURLSearchParams.get('cup'),
        'Stampante': currURLSearchParams.get('stampante') || '(nessuna)',
        'Scontrino': currURLSearchParams.get('stamparescontrino') === 'true' ? 'Sì' : 'No',
    };

    return (
        <div className="card-body">
            <h5 className="card-title">{isCoupon ? 'Conferma Coupon' : 'Conferma DDT'}</h5>
            <p className="text-muted">
                {isCoupon
                    ? 'Indica il cellulare del conducente, verifica i dati e conferma per salvare il coupon.'
                    : 'Verifica i dati e conferma per salvare il DDT.'}
            </p>

            <form onSubmit={handleSubmit}>
                {isCoupon && (
                    <div className="mb-3">
                        <label htmlFor="cellulare" className="form-label">Cellulare conducente</label>
                        <InputText
                            id="cellulare"
                            value={cellulare}
                            onChange={(e) => setCellulare(e.target.value)}
                            className={`w-100 ${cellulare && !cellulareOk ? 'p-invalid' : ''}`}
                            inputMode="tel"
                            autoFocus
                        />
                        <small className="text-muted">
                            Obbligatorio: a questo numero viene inviato l&rsquo;SMS con i dati del coupon.
                        </small>
                    </div>
                )}

                <table className="table table-striped">
                    <tbody>
                        {Object.entries(dati).map(([key, value]) => (
                            value && (
                                <tr key={key}>
                                    <th>{key}</th>
                                    <td>{value}</td>
                                </tr>
                            )
                        ))}
                        {!isCoupon && (
                            <tr className="table-info">
                                <th>Peso Netto</th>
                                <td><strong>{netto.toFixed(2)}</strong></td>
                            </tr>
                        )}
                    </tbody>
                </table>

                <button className="btn btn-success btn-lg w-100" disabled={loading || !cellulareOk}>
                    {loading
                        ? 'Salvataggio...'
                        : (isCoupon ? 'Conferma e Salva Coupon' : 'Conferma e Salva DDT')}
                </button>
            </form>
            
            <ValoriVerificati valori={props.verificaData?.valori_verificati} />
        </div>
    );
}

Conferma.displayName = 'conferma';
